import type { QueryClient } from '@tanstack/react-query'
import type { BriefResponse } from './types'

/**
 * Merge the agent's SSE "state" event into the shared brief query cache.
 *
 * Read-in-place rather than a refetch: the backend commit that persisted this
 * update may not have landed yet when the event streams out, so refetching
 * here would race it and show stale data. The event payload already carries
 * the authoritative post-update brief.
 */
export function applyBriefStateEvent(
  queryClient: QueryClient,
  briefId: string,
  data: Record<string, any>,
) {
  queryClient.setQueryData<BriefResponse>(['brief', briefId], (old) =>
    old
      ? {
          ...old,
          version: typeof data.brief_version === 'number' ? data.brief_version : old.version,
          brief: data.brief ?? old.brief,
          validation: data.validation ?? old.validation,
        }
      : old,
  )
}
